import { Component, OnInit } from '@angular/core';
import { ComunicadosService } from '../comunicados.service';

@Component({
  selector: 'app-mayoristas-comunicados-grupos',
  templateUrl: './mayoristas-comunicados-grupos.component.html',
  styleUrls: [
  	'./mayoristas-comunicados-grupos.component.css',
  	'../../assets/scss/styles.scss',
	'../../assets/scss/general-board.scss', 
    '../../assets/scss/fonts.scss',    
    '../../assets/ema/main.scss',
  ]
})
export class MayoristasComunicadosGruposComponent implements OnInit {
  public comunicados;
  constructor(private comunicadosService: ComunicadosService) { }

  ngOnInit() {
    this.comunicadosService.getAllComunicadosbyCategory('Grupos')
      .then(response => {
        this.comunicados = response;
      })
      .catch(err => console.error(err));
  }

}
